import getConfig from 'next/config'

import { BloomreachSettings, withBloomreach } from '@grandvisionhq/next'

import { featureToggles } from '../configuration/feature-toggles'
import { INTL_DEFAULTS } from '../configuration/intl'

const { isMultilingualEnabled } = featureToggles
import { componentDefinitions, customComponents } from './component-definitions'

const { publicRuntimeConfig } = getConfig()
const { apiUrl } = publicRuntimeConfig.bloomreach ?? {}

const bloomreachSettings: BloomreachSettings = {
  apiUrl,
  componentDefinitions,
  customComponentMap: customComponents,
}

const settings: Parameters<typeof withBloomreach>[0] = {
  bloomreach: bloomreachSettings,
  isMultilingualEnabled,
  defaultLocale: INTL_DEFAULTS.locale,
}

export default withBloomreach(settings)
